var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIrmLogoWithoutName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 40,
    viewBox: "0 0 50 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M17.9431 10.6519L26.841 25.3259L35.8126 39.9999H17.9431H0L8.97153 25.3259L17.9431 10.6519Z",
    fill: "#13487D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M31.5466 0L40.5181 20.0371L49.4896 39.9997H31.5466H13.6035L22.575 20.0371L31.5466 0Z",
    fill: "#1C75BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M24.7094 5.73486L33.6809 22.8669L42.6524 39.999H24.7094H6.83984L15.8114 22.8669L24.7094 5.73486Z",
    fill: "#6DCFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrmLogoWithoutName);
export default __webpack_public_path__ + "static/media/irmLogoWithoutName.1f78019cc1f30ff4fca970561d78a892.svg";
export { ForwardRef as ReactComponent };